// Conditionally run code for local environments
export const isDevelopment = () => {
    return process && process.env && (process.env.NODE_ENV === 'development');
};

// Convert nodeList to Array
export const listToArray = function(node_list) {
    return Array.prototype.slice.call(node_list);
};

// Send an XMLHttpRequest as a Promise
export const sendXHR = function(xhr_parameters, method, token) {
    return new Promise(function (resolve, reject) {
        var request_url = xhr_parameters['request_url'];
        var request_extras = xhr_parameters['request_extras'];
        var request_success = xhr_parameters['request_success'];
        var request_failure = xhr_parameters['request_failure'];
        var is_form_data = false;
        var is_json_data = false;
        var is_ms_graph = false;

        // Check for custom methods
        switch(method) {
            case 'FORM_POST':
                is_form_data = true;
                method = 'POST';
                break;
            case 'JSON_PUT':
                is_json_data = true;
                method = 'PUT';
                request_extras = JSON.stringify(request_extras);
                break;
            case 'MS_GET':
                is_ms_graph = true;
                method = 'GET';
                break;
        }

        // Create XHR
        var xhr = new XMLHttpRequest();

        // Handle timeouts in modern browsers
        xhr.ontimeout = function () {
            console.log("FAIL - HTTP request for '" + request_url + "' timed out.");
        };

        // Handle aborted connections
        xhr.onabort = function () {
            console.log("FAIL - HTTP request for '" + request_url + "' was aborted.");
        };

        // Handle when XHR has processed
        xhr.onreadystatechange = function() {
            if (this.readyState === 4) {
                switch(this.status) {
                    case 200:
                    case 201:
                    case 204:
                        resolve(request_success(this.responseText, request_extras));
                        break;
                    default:
                        resolve(request_failure(this));
                        break;
                }
            }
        };

        // Start the XHR process
        xhr.open(method, request_url, true);
        xhr.timeout = 120000;
        xhr.withCredentials = true;

        if(is_json_data) {
            xhr.setRequestHeader('Accept', 'application/json, text/plain, */*');
            xhr.setRequestHeader('Content-Type', 'application/json');
        }

        if(is_form_data) {
            xhr.setRequestHeader('Accept', 'application/json, text/plain, */*');
            xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
        }

        // Check for authenticated request
        if(typeof(token) !== 'undefined' && token !== null) {
            // Set up headers
            xhr.setRequestHeader('Authorization', token);
        }

        var timeout = 0;

        if(isDevelopment()) {
            // Simulate a real-world environment
            timeout = Math.ceil(Math.random() * 2000);
            console.log(timeout);
        }        

        setTimeout(function(){
            switch(method) {
                case 'GET':
                    xhr.send();
                    break;
                case 'POST':
                case 'PUT':
                case 'DELETE':
                    // This is the request payload
                    xhr.send(request_extras);
                    break;
            }
        }, timeout);
    });
};

// Default failure for XHR call
export const failedRequest = function() {
    console.log('The request failed.');
};

// Debounce function for 
// Example use: debouncer(functionToRun, 200)
export const debouncer = function(func, wait, immediate){
    var timeout;

    return function executedFunction() {
        var context = this;
        var args = arguments;
            
        var later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };

        var callNow = immediate && !timeout;
        
        clearTimeout(timeout);

        timeout = setTimeout(later, wait);
        
        if (callNow) func.apply(context, args);
    };
};

// Find the anchor element from a click event
export const findLink = function(event) {
    var target = event['target'];
    var tag_type = target['tagName'].toLowerCase();
    var found_link = false;

    if(tag_type === 'a'){
        found_link = true;
    }

    // Cater for clicking on child elements of the anchor
    while(!found_link){
        target = target['parentNode'];
        tag_type = target['tagName'].toLowerCase();

        if(tag_type === 'a') {
            found_link = true;
        }
    }

    return target;
};

// Check for current viewport
export const getViewport = function() {
    var viewport_element = document.querySelector('body');
    var element_styles = window.getComputedStyle(viewport_element, null);
    var viewport = parseInt(element_styles['zIndex']);
    
    return viewport;
}

// Check for variable type
export const getVarType = function(object) {
    // Arrays
    if (Array.isArray(object)){
        return "array";
    }

    // String
    if (typeof(object) === "string"){
        return "string";
    }
    
    // Boolean
    if (typeof(object) === "boolean"){
        return "boolean";
    }

    // Undefined
    if (typeof(object) === "undefined"){
        return "undefined";
    }
    
    // Object
    return "object";
}

export const isClickOutside = function(element) {
    if (!element.contains(event.target) && isVisible(element)) {
        return true;
    }
    return false;
}

// Used for Click Listener
const isVisible = elem => !!elem && !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length)


export const validURL = function(str) {
    var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
      '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
    return !!pattern.test(str);
}

// Handle date and time cases
export const makeDate = function(date_input, date_format) {
    var chosen_timezone = 'Australia/Brisbane';
    //chosen_timezone = 'Pacific/Auckland';
    var date_object = new Date(date_input);
    var date_string = date_object.toISOString();
    var utc_format = moment.utc(date_string).format();
    var griffith_date = moment(utc_format).tz(chosen_timezone);

    if(date_format) {
        griffith_date = griffith_date.format(date_format);
    }

    return griffith_date;
};

// Create new date based on now
export const makeDateNow = function(date_format) {
    var initial_date = new Date().toISOString();

    if(date_format) {
        return makeDate(initial_date, date_format);
    }

    return makeDate(initial_date);
};

// Create new date based on unix function
export const makeUnixDate = function(timestamp, date_format) {
    var chosen_timezone = 'Australia/Brisbane';
    var griffith_unix_date = moment.unix(timestamp).tz(chosen_timezone);

    if(date_format) {
        griffith_unix_date = griffith_unix_date.format(date_format);
    }

    return griffith_unix_date;
};

// Compare moment dates
export const checkSameDate = function(date_one, date_two) {
    var date_format = 'YYYY-MM-DD';
    var date_one_formatted = date_one.format(date_format);
    var date_two_formatted = date_two.format(date_format);

    if(date_one_formatted === date_two_formatted) {
        return true;
    }

    return false;
};

// Get dangerous HTML structure
export const getDangerousHTML = function(content) {
    if(content) {
        return {
            '__html': content
        }
    }

    return null;
}